import apiClient from './api';

/**
 * Seguimiento por candidato (pacing / cumplimiento / alertas) — backend: /candidate-tracking/*
 * Todas las respuestas vienen envueltas por ResponseInterceptor: { success, data } → se devuelve data.
 */
const unwrap = (response) => {
  const body = response?.data;
  return body && typeof body === 'object' && 'data' in body ? body.data : body;
};

const candidateTrackingService = {
  async getTracking({ clientId, asOf, flightStart, demo } = {}) {
    const params = { clientId };
    if (asOf) params.asOf = asOf;
    if (flightStart) params.flightStart = flightStart;
    if (demo === true) params.demo = '1'; else if (demo === false) params.demo = '0';
    return unwrap(await apiClient.get('/candidate-tracking/tracking', { params }));
  },
  async getPlan(clientId, flightStart) {
    const params = { clientId };
    if (flightStart) params.flightStart = flightStart;
    return unwrap(await apiClient.get('/candidate-tracking/plan', { params }));
  },
  async savePlanRow(clientId, row) {
    if (row.id) return unwrap(await apiClient.put(`/candidate-tracking/plan/${row.id}`, row, { params: { clientId } }));
    return unwrap(await apiClient.post('/candidate-tracking/plan', row, { params: { clientId } }));
  },
  async deletePlanRow(clientId, id) {
    return unwrap(await apiClient.delete(`/candidate-tracking/plan/${id}`, { params: { clientId } }));
  },
  async importPlan(clientId, file, { replace = false } = {}) {
    const form = new FormData();
    form.append('file', file);
    return unwrap(await apiClient.post('/candidate-tracking/plan/import', form, {
      params: { clientId, replace: replace ? 'true' : 'false' },
      headers: { 'Content-Type': 'multipart/form-data' },
    }));
  },
  async getConfig(clientId) {
    return unwrap(await apiClient.get('/candidate-tracking/config', { params: { clientId } }));
  },
  async updateConfig(clientId, patch) {
    return unwrap(await apiClient.put('/candidate-tracking/config', patch, { params: { clientId } }));
  },
  async setCheck(clientId, planId, date, note) {
    return unwrap(await apiClient.post('/candidate-tracking/check', { planId, date, note }, { params: { clientId } }));
  },
  async removeCheck(clientId, planId, date) {
    return unwrap(await apiClient.delete('/candidate-tracking/check', { params: { clientId, planId, date } }));
  },
  async getRules(clientId) {
    return unwrap(await apiClient.get('/candidate-tracking/rules', { params: { clientId } }));
  },
  async replaceRules(clientId, rules) {
    return unwrap(await apiClient.put('/candidate-tracking/rules', { rules }, { params: { clientId } }));
  },
};

export default candidateTrackingService;
